module.exports = __webpack_public_path__ + "static/media/16_shape_l.c97a8453.webp";